import React, { useState } from "react";

import {
  Box, InputAdornment, Grid,
  Avatar,
  Typography,
  MobileStepper,
  TextField,
  Select,
  MenuItem,
  IconButton,
  iconList,
  Button,
} from "@mui/material";
import ProjectHeaderLogo from "assets/images/Group 1171275838.svg";
import ProjectImage from "assets/images/NotebookImage.svg";
import { FaRegCalendarAlt } from "react-icons/fa";


const ThirdStep = ({ formik, handleClick, handlePrevious, activeStep, steps }) => {

  const [projectType, setProjectType] = useState("");
  const [selectedIcon, setSelectedIcon] = useState("📊")
  const [currency, setCurrency] = useState("INR");
  const [amount, setAmount] = useState("");


  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f3f3f3",
          minHeight: "100vh",
          p: { xs: "24px 16px", sm: "40px 24px", md: "80px 0px 0px 132px" },
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "flex-end" },
            gap: { xs: 5, sm: 6, md: 8, lg: "326px" },
            width: "100%",
            maxWidth: "100%",
            p: { xs: 0, sm: 0, md: "7px 132px 21px 0px" },
            boxSizing: "border-box",
          }}
        >
          {/* Left Section */}
          <Box
            sx={{
              flex: 1,
              width: { xs: "100%", sm: "100%", md: "525px" },
              maxWidth: "525px",
              display: "flex",
              flexDirection: "column",
              boxSizing: "border-box",

            }}
          >
            {/* Logo */}
            <Avatar
              src={ProjectHeaderLogo}
              sx={{
                width: { xs: 50, sm: 60, md: 60 },
                height: { xs: 50, sm: 60, md: 60 },
                bgcolor: "transparent",
                "& img": {
                  objectFit: "contain",
                  width: "100%",
                  height: "100%",
                },
              }}
            />
            <Box sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: "13px",
              width: "100%",
            }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "flex-start", width: "100%", p: 0 }}>
                <Typography
                  sx={{
                    mt: "0px",
                    fontWeight: 700,
                    fontSize: { xs: "28px", sm: "32px", md: "36px" },
                    lineHeight: 1.1,
                    fontFamily: "Outfit, sans-serif",
                    color: "#252C32",
                  }}
                >
                  Business Info
                </Typography>

                {/* Stepper */}
                <MobileStepper
                  variant="progress"
                  steps={steps}
                  position="relative"
                  activeStep={activeStep}
                  sx={{
                    width: { xs: "110%", sm: "110%", md: "105%" },
                    mt: 0,
                    p: 0,
                    background: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "& .MuiMobileStepper-progress": {
                      flexGrow: 1,
                      width: "100%",
                    },
                    "& .MuiLinearProgress-root": {
                      width: "100%",
                      backgroundColor: "#E9E9E9",
                      height: 4,
                      borderRadius: "4px",
                    },
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#143DF2",
                    },
                  }}
                />

              </Box>
              <Typography sx={{
                fontSize: "18px",
                fontWeight: 500,
                color: "#9B9C9F",
                letterSpacing: "0px",
                fontFamily: "Outfit"
              }}>
                3/4
              </Typography>
            </Box>

            {/* Description Texts */}
            <Box
              sx={{
                mt: "15px",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: 1.3,
                  fontFamily: "Outfit, sans-serif",
                  color: "#5B5772",
                }}
              >
                Explore what’s possible when you collaborate with your team. Edit
                project details anytime in project settings.
              </Typography>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: 1.3,
                  fontFamily: "Outfit, sans-serif",
                  color: "#5B5772",
                }}
              >
                Required fields are marked with an asterisk{" "}
                <Box component="span" sx={{ color: "#D92D20" }}>
                  *
                </Box>
              </Typography>
            </Box>

            {/* Form Fields */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", mt: "30px" }}>

              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  fontFamily: "Outfit, sans-serif",
                  color: "#5F5F5F",
                }}
              >
                Client Business Name{" "}
                <Box component="span" sx={{ color: "#D92D20" }}>
                  *
                </Box>
              </Typography>
              <TextField
                placeholder="Client Business Name"
                fullWidth
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                }}
                sx={{

                  "& .MuiInput-root": {
                    borderRadius: "8px",
                    backgroundColor: "#FFFFFF",
                    height: 48,
                    px: 2,
                    display: "flex",
                    alignItems: "center",
                  },
                  "& .MuiInput-input": {
                    fontFamily: "Outfit, sans-serif",
                    padding: 0,
                    color: "#0A0A0C",
                    "&:-webkit-autofill": {
                      WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                      WebkitTextFillColor: "#0A0A0C !important",
                      borderRadius: "8px",
                    },
                    "&:-webkit-autofill:hover": {
                      WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                    },
                    "&:-webkit-autofill:focus": {
                      WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                    },
                  },
                }}
                name="client_business_name"
                value={formik.values.client_business_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.client_business_name && Boolean(formik.errors.client_business_name)}
                helperText={formik.touched.client_business_name && formik.errors.client_business_name}
              />


            </Box>

            {/* Project Type */}
            <Box sx={{ mt: "15px" }}>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  fontFamily: "Outfit, sans-serif",
                  color: "#5F5F5F",
                }}
              >
                Contractor Business Name{" "}
                <Box component="span" sx={{ color: "#D92D20" }}>
                  *
                </Box>
                <Grid container>
                  <Grid size={12}>
                    <TextField
                      placeholder="Contractor Business Name"
                      fullWidth
                      variant="standard"
                      InputProps={{
                        disableUnderline: true,
                      }}
                      sx={{
                        mt: "15px",
                        "& .MuiInput-root": {
                          borderRadius: "8px",
                          backgroundColor: "#FFFFFF",
                          height: 48,
                          px: 2,
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiInput-input": {
                          fontFamily: "Outfit, sans-serif",
                          padding: 0,
                          color: "#0A0A0C",
                          "&:-webkit-autofill": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                            WebkitTextFillColor: "#0A0A0C !important",
                            borderRadius: "8px",
                          },
                          "&:-webkit-autofill:hover": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          },
                          "&:-webkit-autofill:focus": {
                            WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          },
                        },
                      }}
                      name="contractor_business_name"
                      value={formik.values.contractor_business_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.contractor_business_name && Boolean(formik.errors.contractor_business_name)}
                      helperText={formik.touched.contractor_business_name && formik.errors.contractor_business_name}
                    />
                  </Grid>

                </Grid>

              </Typography>

            </Box>
            <Box sx={{ mt: "15px" }}>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  fontFamily: "Outfit, sans-serif",
                  color: "#5F5F5F",
                }}
              >
                Contractor Number {" "}
                <Box component="span" sx={{ color: "#D92D20" }}>
                  *
                </Box>
              </Typography>
              <Grid size={12}>
                <TextField
                  placeholder="123456780"
                  sx={{
                    mt: "15px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "6px",
                      backgroundColor: "#ECECEC",
                      height: 44,
                      width: { xs: "auto", md: "334px" },
                      border: "none",
                      overflow: "hidden",
                    },
                    "& .MuiOutlinedInput-input": {
                      px: 2,
                      fontFamily: "Outfit, sans-serif",
                      "&:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 100px #ECECEC inset !important", // 100px for full coverage
                        WebkitTextFillColor: "#0A0A0C !important",
                        borderRadius: "6px",
                        // नई properties add करें
                        transition: "background-color 5000s ease-in-out 0s", // लंबा transition
                        backgroundColor: "#ECECEC !important", // explicit background color
                        caretColor: "#0A0A0C !important", // cursor color
                      },
                      "&:-webkit-autofill:hover": {
                        WebkitBoxShadow: "0 0 0 100px #ECECEC inset !important",
                        WebkitTextFillColor: "#0A0A0C !important",
                        backgroundColor: "#ECECEC !important",
                      },
                      "&:-webkit-autofill:focus": {
                        WebkitBoxShadow: "0 0 0 100px #ECECEC inset !important",
                        WebkitTextFillColor: "#0A0A0C !important",
                        backgroundColor: "#ECECEC !important",
                      },
                      "&:-webkit-autofill:active": {
                        WebkitBoxShadow: "0 0 0 100px #ECECEC inset !important",
                        WebkitTextFillColor: "#0A0A0C !important",
                        backgroundColor: "#ECECEC !important",
                      },
                    },
                  }}
                  name="contractor_number"
                  value={formik.values.contractor_number}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.contractor_number && Boolean(formik.errors.contractor_number)}
                  helperText={formik.touched.contractor_number && formik.errors.contractor_number}
                />
              </Grid>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", mt: "15px" }}>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  fontFamily: "Outfit, sans-serif",
                  color: "#5F5F5F",
                }}
              >
                Budget Info
              </Typography>
              <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: "15px", }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  {/* Currency + Amount container */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "191px",
                      height: "34px",
                      backgroundColor: "#E7E7EB",
                      borderRadius: "8px",
                      px: "8px",
                      boxSizing: "border-box",
                    }}
                  >
                    {/* Left Side - Currency Dropdown */}
                    <TextField
                      select
                      variant="standard"
                      InputProps={{ disableUnderline: true }}
                      sx={{
                        width: "55px",
                        "& .MuiSelect-select": {
                          p: 0,
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "#0A0A0C",
                          letterSpacing: "1%",
                          display: "flex",
                          alignItems: "center",
                          fontFamily: "Outfit, sans-serif",
                        },
                      }}
                      name="currency_budget"
                      value={formik.values.currency_budget}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <MenuItem value="INR">INR</MenuItem>
                      <MenuItem value="USD">USD</MenuItem>
                      <MenuItem value="EUR">EUR</MenuItem>
                    </TextField>

                    {/* Divider */}
                    <Box
                      sx={{
                        width: "1px",
                        height: "60%",
                        backgroundColor: "#C8C8C8",
                      }}
                    />

                    {/* Right Side - Amount Field */}
                    <TextField
                      placeholder="Budgeted Cost"
                      variant="standard"
                      InputProps={{
                        disableUnderline: true,
                      }}
                      sx={{
                        flex: 1,
                        ml: "8px",
                        "& input": {
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "#0A0A0C",
                          letterSpacing: "1%",
                          p: 0,
                          fontFamily: "Outfit",
                          "&:-webkit-autofill": {
                            WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                            WebkitTextFillColor: "#0A0A0C !important",
                          },
                          "&:-webkit-autofill:hover": {
                            WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                          },
                          "&:-webkit-autofill:focus": {
                            WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                          },
                        },
                        "& input::placeholder": {
                          color: "#8C8C8C",
                          fontFamily: "Outfit, sans-serif",
                        },
                      }}
                      name="budgeted_cost"
                      value={formik.values.budgeted_cost}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Box>

                  {/* Error Messages Outside (nowrap) */}
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    {formik.touched.currency_budget && formik.errors.currency_budget && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                          mt: "2px",
                          fontFamily: "Outfit, sans-serif",
                        }}
                      >
                        {formik.errors.currency_budget}
                      </Typography>
                    )}

                    {formik.touched.budgeted_cost && formik.errors.budgeted_cost && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                          mt: "2px",
                          fontFamily: "Outfit, sans-serif",
                        }}
                      >
                        {formik.errors.budgeted_cost}
                      </Typography>
                    )}
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  {/* Currency + Amount container */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "191px",
                      height: "34px",
                      backgroundColor: "#E7E7EB",
                      borderRadius: "8px",
                      px: "8px",
                      boxSizing: "border-box",
                    }}
                  >
                    {/* Left Side - Currency Dropdown */}
                    <TextField
                      select
                      variant="standard"
                      InputProps={{ disableUnderline: true }}
                      sx={{
                        width: "55px",
                        "& .MuiSelect-select": {
                          p: 0,
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "#0A0A0C",
                          letterSpacing: "1%",
                          display: "flex",
                          alignItems: "center",
                          fontFamily: "Outfit, sans-serif"
                        },
                      }}
                      name="currency_awarded"
                      value={formik.values.currency_awarded}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <MenuItem value="INR">INR</MenuItem>
                      <MenuItem value="USD">USD</MenuItem>
                      <MenuItem value="EUR">EUR</MenuItem>
                    </TextField>

                    {/* Divider */}
                    <Box
                      sx={{
                        width: "1px",
                        height: "60%",
                        backgroundColor: "#C8C8C8",
                      }}
                    />

                    {/* Right Side - Amount Field */}
                    <TextField
                      placeholder="Awarded Cost"
                      variant="standard"
                      InputProps={{
                        disableUnderline: true,
                      }}
                      sx={{
                        flex: 1,
                        ml: "8px",
                        "& input": {
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "#0A0A0C",
                          letterSpacing: "1%",
                          p: 0,
                          fontFamily: "Outfit",
                          "&:-webkit-autofill": {
                            WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                            WebkitTextFillColor: "#0A0A0C !important",
                          },
                          "&:-webkit-autofill:hover": {
                            WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                          },
                          "&:-webkit-autofill:focus": {
                            WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                          },
                        },
                        "& input::placeholder": {
                          color: "#8C8C8C",
                          fontFamily: "Outfit, sans-serif"
                        },
                      }}
                      name="awarded_cost"
                      value={formik.values.awarded_cost}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Box>

                  {/* Error Messages Outside (nowrap) */}
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    {formik.touched.currency_awarded && formik.errors.currency_awarded && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                          mt: "2px",
                          fontFamily: "Outfit, sans-serif"
                        }}
                      >
                        {formik.errors.currency_awarded}
                      </Typography>
                    )}

                    {formik.touched.awarded_cost && formik.errors.awarded_cost && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                          mt: "2px",
                          fontFamily: "Outfit, sans-serif",
                        }}
                      >
                        {formik.errors.awarded_cost}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", mt: "15px" }}>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: "16px",
                  fontFamily: "Outfit, sans-serif",
                  color: "#5F5F5F",
                }}
              >
                Original Budget Info
              </Typography>
              <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: "15px", }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  {/* Currency + Amount container */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "400px",
                      height: "34px",
                      backgroundColor: "#E7E7EB",
                      borderRadius: "8px",
                      px: "8px",
                      boxSizing: "border-box",
                    }}
                  >
                    {/* Left Side - Currency Dropdown */}
                    <TextField
                      select
                      variant="standard"
                      InputProps={{ disableUnderline: true }}
                      sx={{
                        width: "55px",
                        "& .MuiSelect-select": {
                          p: 0,
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "#0A0A0C",
                          letterSpacing: "1%",
                          display: "flex",
                          alignItems: "center",
                          fontFamily: "Outfit, sans-serif",
                        },
                      }}
                      name="currency_original_budget"
                      value={formik.values.currency_original_budget}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <MenuItem value="INR">INR</MenuItem>
                      <MenuItem value="USD">USD</MenuItem>
                      <MenuItem value="EUR">EUR</MenuItem>
                    </TextField>

                    {/* Divider */}
                    <Box
                      sx={{
                        width: "1px",
                        height: "60%",
                        backgroundColor: "#C8C8C8",
                      }}
                    />

                    {/* Right Side - Amount Field */}
                    <TextField
                      placeholder="Original Budgeted Cost"
                      variant="standard"
                      InputProps={{
                        disableUnderline: true,
                      }}
                      sx={{
                        flex: 1,
                        ml: "8px",
                        "& input": {
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "#0A0A0C",
                          letterSpacing: "1%",
                          p: 0,
                          fontFamily: "Outfit",
                          "&:-webkit-autofill": {
                            WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                            WebkitTextFillColor: "#0A0A0C !important",
                          },
                          "&:-webkit-autofill:hover": {
                            WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                          },
                          "&:-webkit-autofill:focus": {
                            WebkitBoxShadow: "0 0 0 100px #E7E7EB inset !important",
                          },
                        },
                        "& input::placeholder": {
                          color: "#8C8C8C",
                          fontFamily: "Outfit, sans-serif",
                        },
                      }}
                      name="original_budgeted_cost"
                      value={formik.values.original_budgeted_cost}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </Box>

                  {/* Error Messages Outside (nowrap) */}
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    {formik.touched.currency_original_budget && formik.errors.currency_original_budget && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                          mt: "2px",
                          fontFamily: "Outfit, sans-serif",
                        }}
                      >
                        {formik.errors.currency_original_budget}
                      </Typography>
                    )}

                    {formik.touched.original_budgeted_cost && formik.errors.original_budgeted_cost && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          whiteSpace: "nowrap",
                          mt: "2px",
                          fontFamily: "Outfit, sans-serif",
                        }}
                      >
                        {formik.errors.original_budgeted_cost}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box sx={{
              mt: "20px",
              display: "flex",
              alignItems: "center",
              gap: "40px"
            }}>

              <Box sx={{
                width: "230px",
                height: "48px",
                borderRadius: "3px",
                backgroundColor: "#00344C",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
                <Button
                  onClick={handleClick}
                  sx={{
                    fontWeight: 500,
                    fontSize: "16px",
                    lineHeight: "16px",
                    letterSpacing: "1%",
                    color: "#FFFFFF",
                    width: "100%",
                    height: "100%",
                    fontFamily: "Outfit, sans-serif",
                    textTransform: "none"
                  }}>
                  Continue
                </Button>
              </Box>
              <Button
                onClick={handlePrevious}
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: "12px",
                  color: "#143DF2",
                  textTransform: "none",
                  letterSpacing: "0%",
                  textDecoration: "underline",
                  p: 0,
                  minWidth: "auto",
                  fontFamily: "Outfit, sans-serif"
                }}
              >
                Previous step
              </Button>
            </Box>

          </Box>

          {/* Right Section (Image) */}
          <Box
            sx={{
              flexShrink: 0,
              width: { xs: "90%", md: "240px", lg: "327px" },
              height: { xs: "250px", md: "270px", lg: "350px" },
              border: "1px solid #ECECEC",
              borderRadius: "3px",
              bgcolor: "#FFFFFF",
              display: "flex",
              flexDirection: "column",
              mt: { xs: 4, md: 0 },
              p: "30px",
              alignSelf: { xs: "center", md: "center" },
            }}
          >
            <Box sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",

            }}>
              <Box
                component="img"
                src={ProjectImage}
                alt="Project preview"
                sx={{
                  width: { sm: "200px", md: "238px" },
                  height: "200",
                  objectFit: "contain",
                }}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", mt: "18px", gap: "16px" }}>
              <Typography sx={{ fontSize: "16px", fontWeight: "600", lineHeight: "100%", color: "#3F3F3F", fontFamily: "Outfit, sans-serif" }}>
                Manage EPC Project
              </Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "100%", color: "#3F3F3F", fontFamily: "Outfit, sans-serif" }}>
                Manage design projects effectively, visualize tasks, and see team workload
              </Typography>
            </Box>

          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ThirdStep;
